<template>
  <div class="gc-index-wrap">
    <van-nav-bar :border="false"
                 title="统计"
                 left-arrow
                 @click-left="$router.back()"
    />

    <!-- 部门 -->
    <div v-if="isDep" class="gc-index-data-wrap gc-index-leader-wrap">
      <div class="now-month-wrap">
        <div class="item-data-title">部门本月数据统计<i :class="{'open':!isEye}" @click="handleEye"></i></div>
        <ul class="now-month-menu">
          <router-link tag="li" :to="{name:'Cost',query:{status:1}}" class="item">
            <i class="i1"></i>
            <div class="info">
              <p class="p1">成本</p>
              <p class="p2">{{ isEye ? '****' : '¥' + (nowMonthDep.PayMoney || 0) }}</p>
            </div>
          </router-link>
          <router-link tag="li" :to="{name:'Income',query:{status:1}}" class="item">
            <i class="i2"></i>
            <div class="info">
              <p class="p1">收入</p>
              <p class="p2">{{ isEye ? '****' : '¥' + (nowMonthDep.GetMoney || 0) }}</p>
            </div>
          </router-link>
        </ul>
      </div>
      <div class="cost-income-wrap">
        <div class="item-data-title">成本收入对比</div>
        <div class="cost-income-data-wrap">
          <div class="tip">数量：万元</div>
          <div class="cost-income-data" id="main0"></div>
        </div>
      </div>
      <div class="prev-month-wrap">
        <div class="item-data-title" style="margin-top:0.8rem">部门上月数据统计</div>
        <ul class="prev-month-menu">
          <li class="item">
            <p class="p1">{{ isEye ? '****' : '¥' + (prevMonthDep.PayMoney || 0) }}</p>
            <p class="p2">上月成本</p>
          </li>
          <li class="item">
            <p class="p1">{{ isEye ? '****' : '¥' + (prevMonthDep.GetMoney || 0) }}</p>
            <p class="p2">上月收入</p>
          </li>
          <li class="item">
            <p class="p1">{{ Number(prevMonthDep.OverMoney || 0).toFixed(0) }}%</p>
            <p class="p2">上月完成率</p>
          </li>
          <li class="item">
            <p class="p1">第{{ prevMonthDep.OverMoneyOrderNumber || 0 }}名</p>
            <p class="p2">上月排名</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- boss开始 -->
    <div v-if="isBoss" class="gc-index-data-wrap">
      <div class="now-month-wrap">
        <div class="item-data-title">公司本月数据统计<i :class="{'open':!isEye}" @click="handleEye"></i></div>
        <ul class="now-month-menu">
          <router-link tag="li" :to="{name:'Cost',query:{status:2}}" class="item">
            <i class="i1"></i>
            <div class="info">
              <p class="p1">成本</p>
              <p class="p2">{{ isEye ? '****' : '¥' + (nowMonthCom.PayMoney || 0) }}</p>
            </div>
          </router-link>
          <router-link tag="li" :to="{name:'Income',query:{status:2}}" class="item">
            <i class="i2"></i>
            <div class="info">
              <p class="p1">收入</p>
              <p class="p2">{{ isEye ? '****' : '¥' + (nowMonthCom.GetMoney || 0) }}</p>
            </div>
          </router-link>
        </ul>
      </div>
      <div class="jindu-wrap mt100">
        <div class="item-data-title">总完成进度</div>
        <van-slider class="jindu-slider" v-model="value" disabled bar-height=".25rem" active-color="#D32F2F" inactive-color="#eee">
          <template #button>
            <div class="custom-button">{{ value }}%</div>
          </template>
        </van-slider>
      </div>
      <div class="prev-month-wrap" style="margin-top:1.4rem">
        <div class="item-data-title">上月数据概况</div>
        <ul class="prev-month-menu">
          <li class="item">
            <p class="p1">{{ isEye ? '****' : '¥' + (prevMonthCom.PayMoney || 0) }}</p>
            <p class="p2">上月成本</p>
          </li>
          <li class="item">
            <p class="p1">{{ isEye ? '****' : '¥' + (prevMonthCom.GetMoney || 0) }}</p>
            <p class="p2">上月收入</p>
          </li>
          <li class="item">
            <p class="p1">{{ Number(prevMonthCom.OverMoney || 0).toFixed(0) }}%</p>
            <p class="p2">上月完成率</p>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="isBoss" class="gc-index-data-wrap gc-index-leader-wrap">
      <div class="cost-income-wrap" style="margin-top:0">
        <div class="item-data-title">部门成本收入对比</div>
        <div class="cost-income-data-wrap">
          <div class="tip">数量：万元</div>
          <div class="cost-income-data" id="main1"></div>
        </div>
      </div>
      <div class="cost-income-wrap">
        <div class="item-data-title">近半年部门收入对比</div>
        <div class="cost-income-data-wrap">
          <div class="tip">数量：百分比</div>
          <div class="cost-income-data" id="main2"></div>
        </div>
      </div>
    </div>
    <div v-if="isBoss" class="gc-index-data-wrap gc-index-leader-wrap">
      <div class="now-month-wrap">
        <div class="item-data-title">本月个人数据统计</div>
        <ul class="now-month-menu">
          <li class="item">
            <i class="i1"></i>
            <div class="info">
              <p class="p1">本月成本</p>
              <p class="p2">{{ isEye ? '****' : '¥' + (nowMonth.PayMoney || 0) }}</p>
            </div>
          </li>
          <li class="item">
            <i class="i2"></i>
            <div class="info">
              <p class="p1">本月收入</p>
              <p class="p2">{{ isEye ? '****' : '¥' + (nowMonth.GetMoney || 0) }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="now-month-wrap mt100">
        <div class="item-data-title">上月个人数据概况</div>
        <ul class="now-month-menu">
          <li class="item">
            <i class="i1"></i>
            <div class="info">
              <p class="p1">上月成本</p>
              <p class="p2">{{ isEye ? '****' : '¥' + (prevMonth.PayMoney || 0) }}</p>
            </div>
          </li>
          <li class="item">
            <i class="i2"></i>
            <div class="info">
              <p class="p1">上月收入</p>
              <p class="p2">{{ isEye ? '****' : '¥' + (prevMonth.GetMoney || 0) }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- boss结束 -->


  </div>
</template>

<script>
export default {
  data() {
    return {
      isEye: true,

      isDep: false, //是否是部门负责人
      isBoss: false, //是否是老板

      // 部门对比
      depList: [],
      depListInMoney: [],
      depListOutMoney: [],
      // 个人对比
      userList: [],
      userListInMoney: [],
      userListOutMoney: [],
      // 近半年部门收入
      depList2: [],
      depList2Month: [],
      depList2Money: [],

      // 个人数据
      nowMonth: {},
      prevMonth: {},
      // 部门数据
      nowMonthDep: {},
      prevMonthDep: {},
      // 公司数据
      nowMonthCom: {},
      prevMonthCom: {},
    }
  },
  mounted() {

    this.isBoss = localStorage.getItem('isBoss') == 1 ? true : false

    this.isDep = localStorage.getItem('ReponseLog') == 1 ? true : false


    let now = new Date();
    let year = now.getFullYear();
    let month = now.getMonth() + 1;
    let prev = new Date(year, month - 2)
    let prevYear = prev.getFullYear()
    let prevMonth = prev.getMonth() + 1

    month = month < 10 ? '0' + month : month;
    prevMonth = prevMonth < 10 ? '0' + prevMonth : prevMonth;
    // 个人本月数据
    this.WebGetBUserMoneyDetail(year + '-' + month, true);
    // 个人上月数据
    this.WebGetBUserMoneyDetail(prevYear + '-' + prevMonth, false);
    // 项目完成率
    if (!this.isBoss) {
      this.WebGetEndPr();
    } else {
      this.WebGetComEndPr();
    }


    if (this.isDep) {
      // 部门本月数据
      this.WebGetDepMoneyDetail(year + '-' + month, true);
      // 部门上月数据
      this.WebGetDepMoneyDetail(prevYear + '-' + prevMonth, false);
      // 部门员工对比
      this.WebGetAllDepUserMoneyItem()
      // this.drawChart0();
    }
    if (this.isBoss) {
      // 公司本月数据
      this.WebGetComMoneyDetail(year + '-' + month, true);
      // 公司上月数据
      this.WebGetComMoneyDetail(prevYear + '-' + prevMonth, false);
      // 各部门成本收入对比
      this.WebGetAllDepMoneyItem();
      // 近半年部门收入
      this.WebGetComDepDcitem();
    }


  },
  methods: {
    handleEye() {
      this.isEye = !this.isEye
    },
    drawChart0() {
      // 指定图表的配置项和数据
      var option = {
        grid: {
          top: 40,
          left: 50,
          right: 10,
          bottom: 20
        },
        tooltip: {},
        legend: {
          data: ['成本', '收入'],
          top: 0,
          left: 0,
          itemWidth: 12,
          itemHeight: 8,
          textStyle: {
            fontSize: 10
          }
        },
        yAxis: {
          data: this.userList,
          axisLine: {
            lineStyle: {
              type: 'dashed',
              color: '#cfcfcf'
            }
          },
          axisLabel: {
            interval: 0,
            // rotate: 40
          }

        },
        xAxis: {
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#cfcfcf'
            }
          }
        },
        series: [
          {
            name: '成本',
            type: 'bar',
            barWidth: 8,
            data: this.userListOutMoney,
            color: '#4c52be',
          },
          {
            name: '收入',
            type: 'bar',
            barWidth: 8,
            data: this.userListInMoney,
            color: '#D32F2F'
          },
        ]
      };
      document.getElementById('main0').style.height = `${0.54 + option.yAxis.data.length * 1}rem`


      var myChart = this.$echarts.init(document.getElementById('main0'));
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    drawChart1() {
      var myChart = this.$echarts.init(document.getElementById('main1'));

      // 指定图表的配置项和数据
      var option = {
        grid: {
          top: 40,
          left: 30,
          right: 5,
          bottom: 20
        },
        tooltip: {},
        legend: {
          data: ['成本', '收入'],
          top: 0,
          left: 0,
          itemWidth: 12,
          itemHeight: 8,
          textStyle: {
            fontSize: 10
          }
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 50

          }
        ],
        // dataZoom:[
        //     {
        //         show: true,
        //         realtime:true,
        //         start: 0,
        //         end: 50
        //     },
        //     {
        //         type: 'inside',
        //         realtime:true,
        //         start: 0,
        //         end: 50
        //     }
        // ],
        xAxis: {
          data: this.depList,
          axisLine: {
            lineStyle: {
              type: 'dashed',
              color: '#cfcfcf'
            }
          },
          axisLabel: {
            interval: 0,
            // rotate: 40
          }

        },
        yAxis: {
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#cfcfcf'
            }
          }
        },
        series: [
          {
            name: '成本',
            type: 'bar',
            barWidth: 8,
            data: this.depListOutMoney,
            color: '#4c52be',
          },
          {
            name: '收入',
            type: 'bar',
            barWidth: 8,
            data: this.depListInMoney,
            color: '#D32F2F'
          },
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    drawChart2() {
      var myChart = this.$echarts.init(document.getElementById('main2'));

      // 指定图表的配置项和数据
      var option = {
        grid: {
          top: 80,
          // top: 40,
          left: 30,
          right: 5,
          bottom: 20
        },
        tooltip: {},
        legend: {
          data: this.depList2,
          top: 0,
          left: 0,
          width: '75%',
          itemWidth: 12,
          itemHeight: 8,
          textStyle: {
            fontSize: 10
          }
        },
        xAxis: {
          data: this.depList2Month,
          axisLine: {
            lineStyle: {
              type: 'dashed',
              color: '#cfcfcf'
            }
          },
          axisLabel: {
            interval: 0,
            // rotate: 40
          }

        },
        yAxis: {
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#cfcfcf'
            }
          }
        },
        series: this.depList2Money
      };
      // console.log(this.depList2Money);
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    // 个人项目完成率
    WebGetEndPr() {
      let data = {}
      if (!this.isBoss) {
        data = {
          UserId: localStorage.getItem('UserSysno')
        }
      }
      this.$baseajax.normalJsonp(this.$base.baseProject + '/WebGetEndPr', data, res => {
        console.log(res);
        res = res.WebGetEndPrResult
        if (res.ResponseCode == 1) {
          this.value = Number(Number(res.ReponseLog).toFixed(0))
        }
      }, err => {
      })
    },
    // 公司项目总完成率
    WebGetComEndPr() {
      let data = {}
      this.$baseajax.normalJsonp(this.$base.baseProject + '/WebGetComEndPr', data, res => {
        console.log(res);
        res = res.WebGetComEndPrResult
        if (res.ResponseCode == 1) {
          this.value = Number(Number(res.ReponseLog).toFixed(0))
        }
      }, err => {
      })
    },
    // 各部门成本收入对比
    WebGetAllDepMoneyItem() {
      let data = {
        // RequestDate:'' //默认是当月
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebGetAllDepMoneyItem', data, res => {
        console.log(res);
        res = res.WebGetAllDepMoneyItemResult
        if (res.ResponseCode == 1) {
          for (let item of res.lst) {
            this.depList.push({
              value: item.Name.replace(/中心|总经办-/, ''),
              textStyle: {
                color: '#666',
                fontSize: 10
              }
            })
            this.depListInMoney.push(Number(item.DcMoney / 10000).toFixed(2))
            this.depListOutMoney.push(Number(item.AcMoney / 10000).toFixed(2))

          }
          this.drawChart1();
        }
      }, err => {
      })
    },
    // 部门员工对比
    WebGetAllDepUserMoneyItem() {
      let data = {
        // RequestDate:'' //默认是当月
        DepSysno: localStorage.getItem('GovDepSysno')
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebGetAllDepUserMoneyItem', data, res => {
        console.log(res);
        res = res.WebGetAllDepUserMoneyItemResult
        if (res.ResponseCode == 1) {
          for (let item of res.lst) {
            this.userList.push({
              value: item.Name,
              textStyle: {
                color: '#666',
                fontSize: 10
              }
            })
            this.userListInMoney.push(Number(item.DcMoney / 10000).toFixed(2))
            this.userListOutMoney.push(Number(item.AcMoney / 10000).toFixed(2))

          }
          this.drawChart0();
        }
      }, err => {
      })
    },
    // 近半年部门收入对比
    WebGetComDepDcitem() {
      let data = {
        // RequestDate:'' //默认是当月
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebGetComDepDcitem', data, res => {
        console.log(res);
        res = res.WebGetComDepDcitemResult
        if (res.ResponseCode == 1) {
          let colorList = ['red', 'orange', 'yellow', '#33e238', 'green', '#4ec8c8', '#4c52be', 'purple', '#111']
          for (let index in res.ItemLst) {

            // 部门
            this.depList2.push(res.ItemLst[index].catg_name)
            this.depList2Money.push({
              name: res.ItemLst[index].catg_name,
              type: 'line',
              data: [],
              color: colorList[index],
              smooth: true
            })

            for (let item2 of res.ItemLst[index].list) {
              this.depList2Money[index].data.push(Number(item2.allmoney / 10000).toFixed(2))
            }

          }
          for (let item of res.ItemLst[0].list) {
            // 月份
            this.depList2Month.push({
              value: item.yearmonth,
              textStyle: {
                color: '#666',
                fontSize: 10
              }
            })
          }
          this.drawChart2();
        }
      }, err => {
      })
    },
    // 个人数据
    WebGetBUserMoneyDetail(date, flag) {
      let data = {
        UserSysno: localStorage.getItem('UserSysno'),
        RequestDate: date,
        ComSysno: localStorage.getItem('UserComSysno'),
        DepSysno: localStorage.getItem('GovDepSysno'),
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebGetBUserMoneyDetail', data, res => {
        console.log(res);
        res = res.WebGetBUserMoneyDetailResult
        if (res.ResponseCode == 1) {
          if (flag) {
            this.nowMonth = res.Item || ''
          } else {
            this.prevMonth = res.Item || ''
          }
        } else {
          this.$toast(res.ResponseMessage)
        }
      }, err => {
      })
    },
    // 部门数据
    WebGetDepMoneyDetail(date, flag) {
      let data = {
        RequestDate: date,
        ComSysno: localStorage.getItem('UserComSysno'),
        DepSysno: localStorage.getItem('GovDepSysno'),
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebGetDepMoneyDetail', data, res => {
        console.log(res);
        res = res.WebGetDepMoneyDetailResult
        if (res.ResponseCode == 1) {
          if (flag) {
            this.nowMonthDep = res.Item || ''
          } else {
            this.prevMonthDep = res.Item || ''
          }
        } else {
          this.$toast(res.ResponseMessage)
        }
      }, err => {
      })
    },
    // 公司数据
    WebGetComMoneyDetail(date, flag) {
      let data = {
        RequestDate: date,
        ComSysno: localStorage.getItem('UserComSysno'),
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebGetComMoneyDetail', data, res => {
        console.log(res);
        res = res.WebGetComMoneyDetailResult
        if (res.ResponseCode == 1) {
          if (flag) {
            this.nowMonthCom = res.Item || ''
          } else {
            this.prevMonthCom = res.Item || ''
          }
        } else {
          this.$toast(res.ResponseMessage)
        }
      }, err => {
      })
    },

  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/base.less';

.van-nav-bar {
  background: none;
}

.gc-index-wrap {
  background-image: linear-gradient(135deg, #D32F2F 0%, #1A1A1A 100%);
  background-size: 100% 5.8rem;
  background-repeat: no-repeat;
  padding-bottom: 1.6rem;
  padding-bottom: 0.6rem;
}

.gc-index-top-wrap {
  padding: .5rem .28rem;
  display: flex;
  justify-content: space-between;

  .user-info {
    display: flex;
    align-items: center;

    img {
      width: 1.4rem;
      height: 1.4rem;
      border-radius: 100%;
      margin-right: 0.4rem;
      object-fit: cover;
    }

    .info {
      font-size: 0.32rem;
      color: #ffffff;
    }

    .t {
      font-size: 0.48rem;
    }
  }

  .icon-msg {
    position: relative;

    .i1 {
      display: block;
      width: 0.6rem;
      height: 0.48rem;
      background-image: url('~@/assets/msg.png');
      background-size: contain;
    }

    em {
      position: absolute;
      top: -0.1rem;
      right: -0.1rem;
      width: 0.25rem;
      height: 0.25rem;
      border-radius: 100%;
      background-color: #D32F2F;
    }
  }
}

.gc-index-data-wrap {
  margin-left: 0.28rem;
  margin-right: 0.28rem;
  padding: .5rem;
  background-color: #ffffff;
  box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
  border-radius: 0.27rem;
}

.item-data-title {
  font-size: 0.4rem;
  color: #333333;

  i {
    display: inline-block;
    vertical-align: middle;
    margin-left: 0.2rem;
    width: 0.5rem;
    height: .4rem;
    background-image: url('~@/assets/eye.png');
    background-size: contain;
    background-repeat: no-repeat;

    &.open {
      background-image: url('~@/assets/eye2.png');
    }
  }
}

.now-month-menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  .item {
    display: flex;
    align-items: center;
    margin-top: 0.8rem;
    width: 3.7rem;

    i {
      width: 0.92rem;
      height: 0.92rem;
      margin-right: 0.36rem;
      background-size: contain;
      background-repeat: no-repeat;

      &.i1 {
        background-image: url('~@/assets/data1.png');
      }

      &.i2 {
        background-image: url('~@/assets/data2.png');
      }

      &.i3 {
        background-image: url('~@/assets/data3.png');
      }

      &.i4 {
        background-image: url('~@/assets/data4.png');
      }
    }

    .info {
      font-size: 0.33rem;
      color: #333333;
    }

    .p2 {
      margin-top: 0.08rem;
      color: #f2862f;
      font-weight: 700;
    }
  }
}

.prev-month-menu {
  display: flex;
  justify-content: space-between;

  .item {
    margin-top: 0.8rem;
    text-align: center;

    .p1 {
      font-size: 0.38rem;
      color: @color;
      font-weight: 700;
    }

    .p2 {
      margin-top: 0.2rem;
      font-size: 0.33rem;
      color: #666666;
    }
  }

}

.jindu-slider {
  margin-top: 0.8rem;
  opacity: 1;

  /deep/ .van-slider__button-wrapper {
    margin-top: 0.6rem;
  }

  /deep/ .custom-button {
    font-size: 0.3rem;
    color: #666666;
  }
}

.gc-index-project-wrap {
  margin: 0.28rem .28rem 0;
  padding: .48rem;
  background-color: #ffffff;
  box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
  border-radius: 0.27rem;

  .title {
    font-size: 0.4rem;
    color: #333333;
    display: flex;
    align-items: center;

    &:before {
      content: '';
      width: 0.08rem;
      height: 0.25rem;
      margin-right: 0.1rem;
      background-color: #D32F2F;
    }

    &.title2:before {
      background-color: #8082ea;
    }
  }

  .item {
    padding: .4rem 0;
    border-top: 1px solid #ddd;
    font-size: 0.3rem;
    color: #888888;

    p {
      margin-top: 0.08rem;
      display: flex;
    }

    span {
      font-size: 0.32rem;
      color: #666666;
      width: 1.6rem;
      flex: 0 0 1.6rem;
    }

    &:first-child {
      border-top: none
    }
  }
}

.gc-index-leader-wrap {
  margin-top: 0.28rem;
}

.cost-income-wrap {
  margin-top: 0.8rem;
}

.cost-income-data {
  margin-top: 0.5rem;
  width: 100%;
  height: 5rem;

  &#main0 {
    height: 6rem;
  }

  &#main2 {
    height: 6rem;
  }
}

.cost-income-data-wrap {
  position: relative;

  .tip {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 0.24rem;
    color: #999999;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/HomeLeader.vue